import type { DatasetResource, ListDatasetsOptions } from "@prequel/import-react";
import { useListDatasets } from "@prequel/import-react";
import type { TableRow } from "@prequel/shared-components";

import ResourceTable, { type FilterField } from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";
import { useDatalakeContext } from "@/pages/import/DatalakesPage/DatalakePage";

const COLUMNS = ["Name", "Provider ID", "Schema", "Table", "Created"];

const DatalakeDatasets = () => {
  const { datalake } = useDatalakeContext();

  const filterFields: FilterField[] = [
    {
      key: "type",
      label: "Type",
      queryParam: "type",
      radio: true,
      options: [
        { value: "fact", label: "Fact" },
        { value: "dimension", label: "Dimension" },
      ],
    },
  ];

  const useQuery = (options: ListDatasetsOptions, filters?: { type?: string }) =>
    useListDatasets({ ...options, ...filters, datalakeId: datalake.id });

  const mapDatasetToRow = (dataset: DatasetResource): TableRow => ({
    id: dataset.id,
    to: `/import/datasets/${dataset.id}`,
    cells: [
      { value: dataset.name || dataset.id },
      // Provider IDs are customer-assigned rather than generated, so they read as names.
      { value: <span className="font-mono text-xs">{dataset.provider_id}</span> },
      { value: <span className="font-mono text-xs">{dataset.datalake_schema}</span> },
      { value: <span className="font-mono text-xs">{dataset.datalake_table_name}</span> },
      { value: <Timestamp timestamp={dataset.created_at} /> },
    ],
  });

  return (
    <ResourceTable<DatasetResource>
      columns={COLUMNS}
      useQuery={useQuery}
      rowMapper={mapDatasetToRow}
      emptyMessage="No datasets are routed to this datalake yet."
      filterFields={filterFields}
    />
  );
};

export default DatalakeDatasets;
